<template>
  <div> <!-- root element of the template -->
    <cm-service-popups></cm-service-popups>
    <cm-service-switcher-popup :closeButton="true"></cm-service-switcher-popup>
    <cm-switch-profile :closeButton="true"></cm-switch-profile>
    <!-- <cm-switch-profile :closeButton="false"></cm-switch-profile> -->
  </div>
</template>

<script>
// contacts
import CMAddContact from '@/popups/contacts/CMAddContact.vue'
import CMAddContactGroup from '@/popups/contacts/CMAddContactGroup.vue'
import CMEditContact from '@/popups/contacts/CMEditContact.vue'
// services
import CMServicePopups from '@/popups/services/Popups.vue'
// service switch
import ServicesSwitcherPopup from '@/popups/ServicesSwitcherPopup.vue'
import ProfileSwitcherPopup from '@/popups/switchProfile/switchProfile.vue'

export default {
  name: 'cm-popups',
  components: {
    'cm-contact-add-popup': CMAddContact,
    'cm-contact-group-add-popup': CMAddContactGroup,
    'cm-contact-edit-popup': CMEditContact,
    'cm-service-popups': CMServicePopups,
    'cm-service-switcher-popup': ServicesSwitcherPopup,
    'cm-switch-profile': ProfileSwitcherPopup
  }
}
</script>



// WEBPACK FOOTER //
// Popups.vue?b524a644